export default __webpack_public_path__ + "static/media/things-to-know-about-startup-business.3df71b0b.md";